import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import LocationValidator from "@/classes/location";
import ForecastService from "@/services/ForecastService";

const vuexPersist = new VuexPersist({
	key: "wb-energydata-app",
	storage: window.localStorage
});

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		locations: []
	},
	mutations: {
		check_locations(state) {
			if (state.locations.length == 0) return true;
			for (var key in state.locations) {
				var result = LocationValidator.validate(state.locations[key]);
				if (result.error) {
					state.locations.splice(key, 1);
				} else {
					store.dispatch("update_location_forecast", {
						key: key,
						location: state.locations[key]
					});
				}
			}
		},
		add_location(state, location) {
			location.created = new Date();
			state.locations.push(location);
		},
		add_locations(state, locations) {
			locations.forEach(location => {
				location.created = new Date();
				state.locations.push(location);
			});
		},
		remove_location(state, location_key) {
			state.locations.splice(location_key, 1);
		},
		update_location(state, args) {
			state.locations[args.key] = args.location;
		}
	},
	actions: {
		update_location_forecast(context, args) {
			ForecastService.location_forecast_autodownload(args.location).then(
				function(data) {
					if (!data) return;
					if (data.forecasts) args.location.forecasts = data.forecasts;
					if (data.updated) args.location.last_update = new Date();
					context.commit("update_location", {
						key: parseInt(args.key),
						location: args.location
					});
				}
			);
		}
	},
	getters: {
		locations(state) {
			return state.locations;
		}
	},
	plugins: [vuexPersist.plugin]
});
